import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-sat',
    templateUrl: './sat.component.html',
    styleUrls: ['./sat.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SatComponent implements OnInit {
  currentYear = new Date().getFullYear();
  constructor() { }

  ngOnInit(): void {
  }

}
